import React, { useEffect } from 'react'
import './style/contactus.css'
import AOS from 'aos';
import 'aos/dist/aos.css';

const ContactUs = () => {
    useEffect(() => {
        AOS.init({
            duration: 800,
            easing: 'ease-in-out',
            once: true
        });
    }, []);
    return (
        <div className='mt-28'>
            <h2 className='text-center text-2xl py-10 font-semibold' data-aos="fade-up">Our Showroom</h2>
            <div className='flex justify-center  flex-wrap md:justify-evenly'>
                <div className='border md:border-0 p-4 md:p-0 w-96 md:w-60   text-center '  data-aos="fade-up" data-aos-delay="100">
                    <h2 className='text-lg font-semibold'>DIAKRAFF DMCC</h2>
                    <address className='text-gray-700'>
                        AlButeen Building 2<br />
                        Office No - 304, 3Nd Floor, <br />Near Gold Souk Gate - 1, <br />Deira, Dubai, UAE
                    </address>
                    <ul  className='mt-5 text-gray-800'>
                        <li>Tel:(00970)524 812 300</li>
                        <li>Fax:(00971)581 257 650</li>
                        <li>MO: (00971)524 815 200</li>
                        <li>diakraff@outlook.com</li>
                        <li>fancydimgroup.com</li>
                    </ul>
                </div>
                <div className='border md:border-0 p-4 md:p-0 w-96 md:w-60  text-center  my-2 md:my-0' data-aos="fade-up" data-aos-delay="200">
                    <h2 className='text-lg font-semibold'>FANCY DIAM INC.</h2>
                    <address className='text-gray-700'>
                        580, Fifth Ave.,<br />
                        Suite 2903, New York, <br />NY 10036, USA.
                    </address>
                    <ul className='mt-5 text-gray-800'>
                        <li>Tel:(001)212 704-0111</li>
                        <li>Fax:(001)212 704-2111</li>
                        <li>Mo:(001)917 244 4572</li>
                        <li>fancydiamusa@gmal.com</li>
                    </ul>
                </div>
                <div className='border md:border-0 p-4 md:p-0 w-96 md:w-60  text-center '  data-aos="fade-up" data-aos-delay="300">
                    <h2 className='text-lg font-semibold'>PINK DIAM LTD.</h2>
                    <address className='text-gray-700'>
                        Yahalom Building 1888-89,<br />
                        Diamond Exchange, 21 Tuval st., <br />
                        Romat Gan, ISRAEL, PO Box-3726<br />
                        Int: 25525.25526
                    </address>
                    <ul className='mt-5 text-gray-800'>
                    <li>Tel:(00972)037263719</li>
                        <li>Fax:(00971)037263455</li>
                        <li>MO: (00971)543456817</li>
                        <li>pinkdiamltd@yahoo.com</li>
                    </ul>
                </div>
                <div className='border md:border-0 p-4 md:p-0 w-96 md:w-60  text-center  my-2 md:my-0'  data-aos="fade-up" data-aos-delay="400">
                    <h2 className='text-lg font-semibold'>FANCY DIAM SRL.</h2>
                    <address className='text-gray-700'>
                        Viale Alessandro manzoni - 16<br />
                        15048-Valenza (AL) ,Italy<br />
                    </address>
                    <ul className='mt-5 text-gray-800'>
                        <li>Mo:+39 339 383 6621</li>
                        <li>Mo:+39 327 396 1160</li>
                        <li>fancydiamitaly@gmail.com</li>
                        <li>www.fancydiamondgroup.com</li>
                    </ul>
                </div>
                <div  className='border md:border-0 p-4 md:p-0 w-96 md:w-60  text-center ' data-aos="fade-up" data-aos-delay="500">
                    <h2 className='text-lg font-semibold'>FANCY DIAM LTD.</h2>
                    <address className='text-gray-700'>
                        1908 ,19/F Multifield Plaza,<br />
                        3-7 A , Prat Avenue,T.S.T<br />
                        Kowloon,Hongkong (Asia)
                    </address>
                    <ul className='mt-5 text-gray-800'>
                        <li>Tel:(00852)23120194</li>
                        <li>Fax:(00852)23120294</li>
                        <li>Mo:(00852)63060801</li>
                        <li>fancydiamltd@yahoo.com</li>
                    </ul>
                </div>
            </div>
            <div className='mt-10 text-center flex justify-center'>

                <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1d48vA9XVxOMaL75LWfo21v_Ers90u3U&ehbc=2E312F" width="900" height="600" zoom='10'  title="Showroom Locations"></iframe>
            </div>
        </div>
    )
}

export default ContactUs
